import React, { Component } from 'react';
import {Label, DatePickerCalendar, Button} from 'app/components/Basics/';
import { Select } from '@ecosystem/ui-lib/core/components/Select';
import './FiltersComponent.scss';
import {ResponseDownloadFormContext} from '../../EdiaryResponseDownloadContext'

class Filters extends Component {

    static contextType = ResponseDownloadFormContext;

    constructor(props){
        super(props);        
    }

	setStartDate(date) {		
		var selectedSelectionFilters = this.context.selectedSelectionFilters;
		selectedSelectionFilters.startDate = date;
		this.context.updateSelectedSelectionFilters(selectedSelectionFilters);
	}

	setEndDate(date) {
		var selectedSelectionFilters = this.context.selectedSelectionFilters;
		selectedSelectionFilters.endDate = date;
		this.context.updateSelectedSelectionFilters(selectedSelectionFilters);
	}

	changeMarketHandler(selectedItem) {
		var selectedSelectionFilters = this.context.selectedSelectionFilters;
		selectedSelectionFilters.regionId = selectedItem.value;		
		this.context.updateSelectedSelectionFilters(selectedSelectionFilters);
    }

	getSelectedMarketOption() {
        return this.props.metadata.regions?.find(t=> t.value === this.context.selectedSelectionFilters.regionId);
    }

	changeSurveyTypeHandler(selectedItem) {
		var selectedSelectionFilters = this.context.selectedSelectionFilters;
		selectedSelectionFilters.subSurveyId = parseInt(selectedItem.value);
		this.context.updateSelectedSelectionFilters(selectedSelectionFilters);
    }

	getSelectedSurveyTypeOption() {
        return this.props.metadata.surveyTypes?.find(t=> parseInt(t.value) === this.context.selectedSelectionFilters.subSurveyId);
    }

    render() {
        return (
            <div>
				<div className="FiltersComponent form-row">
					<div className="form-row-left">
						<div className="field-survey-from">
							<Label>Date From</Label>
							<DatePickerCalendar value={this.context.selectedSelectionFilters.startDate} onChange={this.setStartDate.bind(this)} />
						</div>
						<div className="field-survey-to">
							<Label>Date To</Label>
							<DatePickerCalendar value={this.context.selectedSelectionFilters.endDate} minDate={this.context.selectedSelectionFilters.startDate} onChange={this.setEndDate.bind(this)} />
						</div>
						<div className="field-market">
							<Label>Market</Label>
							<Select name="market" isSearchable={false}
								styles={{ option: styles => ({ minHeight: 40, ...styles }) }}                            
								onChange={val=>{
									this.changeMarketHandler(val)                                
								}}							
								options={this.props.metadata.regions}
								value={this.getSelectedMarketOption()}
								key={this.context.selectedSelectionFilters.regionId}
								>							
							</Select>
						</div>			
						<div className="field-surveytype">
							<Label>Survey Type</Label>
							<Select name="qsetsurveytype" isSearchable={false}
								key={this.context.selectedSelectionFilters.subSurveyId}
								styles={{ option: styles => ({ minHeight: 40, ...styles }) }}								
								onChange={val=>{
									this.changeSurveyTypeHandler(val)                                
								}}
								options={this.props.metadata.surveyTypes} 
								value={this.getSelectedSurveyTypeOption()}>
							</Select>
						</div>
					</div>
					<div className="form-row-right">
					</div>
            	</div>
			</div>
        );
    }
}

Filters.contextType = ResponseDownloadFormContext;

export default Filters;